/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/8/1 9:10
 */
import Loading from 'component/Loading'
import React from 'react'
import { EDITION } from 'types/enum'

interface WithUserInfoPropType {
  payPasswordTag?: any
  userInfo?: UserInfo
  edition: EDITION
  setUserInfo: (useInfo: UserInfo, cb?: () => void) => void
  reloadUserInfo: NoArgVoidFunc
  reloadLetter: NoArgVoidFunc
  logout: NoArgVoidFunc
}

const context = React.createContext({} as WithUserInfoPropType)
const { Provider, Consumer } = context
/**
 * 高阶组件，传递 userInfo
 * 应该包裹在页面最外层组件，因为有 Loading 效果
 * @param Component {function | React.Component}
 * @returns {function(*): *}
 */
export default Component => function withUserInfo (props) {
  return (
    <Consumer>
      {
        ({ userInfo, edition, setUserInfo, reloadUserInfo, reloadLetter, logout }) => (
          userInfo
            ? (
              <Component
                {...props}
                userInfo={userInfo}
                edition={edition}
                setUserInfo={setUserInfo}
                reloadUserInfo={reloadUserInfo}
                reloadLetter={reloadLetter}
                logout={logout}
              />
            )
            : <Loading />
        )
      }
    </Consumer>
  )
}

export { Provider as UserInfoProvider, context as UserInfoContext, WithUserInfoPropType }
